module.exports = __webpack_public_path__ + "static/media/photo266.cacb72b9.jpg";